import { getIdleTimeInMinutes, UserInfo } from "@/entities/session";
import { useIdleTimer } from "react-idle-timer";

export const useSessionIdleLogout = (
    user: UserInfo | null, 
    logout: () => Promise<void>
) => {
    useIdleTimer({
        timeout: 1000 * 60 * getIdleTimeInMinutes(),
        onIdle: () => {
            if (!user) return;
            logout();
        },
        debounce: 500,
        crossTab: false,
        startManually: false,
    });
}